import { isExperience } from '../../../components/utils/listingUtils'

import ShowMoreText from '../../../components/ShowMoreText'
import { Section, SubSection, SectionTitle, SectionSubtitle } from './shared'
import TagList from '../../../components/display/TagList'
import Tag from '../../../components/display/Tag'
import ListingDetailsList from './ListingDetailsList'
import ListingPricing from './ListingPricing'

export default ({ listing }) => (
  <Section noBorder>
    <SectionTitle>Details</SectionTitle>

    {isExperience(listing) && listing.amenities && (
      <SubSection lessMargin>
        <TagList>
          {listing.amenities.map((a) => (
            <Tag key={a.slug} icon={a.slug}>
              {a.name}
            </Tag>
          ))}
        </TagList>
      </SubSection>
    )}

    <ListingDetailsList listing={listing} />

    <SubSection>
      <SectionSubtitle>Additional Information</SectionSubtitle>
      <ShowMoreText lines={5}>{listing.additional_info}</ShowMoreText>
    </SubSection>

    {listing.pricing && (
      <div className="row">
        <div className="col-sm-12">
          <SectionSubtitle>Prices</SectionSubtitle>
          <ListingPricing listing={listing} />
        </div>
      </div>
    )}
  </Section>
)
